import { Type, Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  IntegerField,
  BooleanField,
  SlugField,
  RelationOne,
  RelationField,
} from '@ayocore/platform/common/helpers/schema-types';
import dealTypeSchemaDefinition from './deal-type.schema';

import { name as moduleName } from '../module.json';
/**
 * Статусы сделок — этапы воронки для типа сделки.
 */
export const DealStatusSchema = Type.Object({
  ...SystemFields,

  name: StringField({
    title: 'Название статуса',
    minLength: 1,
    maxLength: 100,
    description: 'Название статуса сделки (например, "В работе", "Закрыта")',
  }),

  slug: SlugField({
    title: 'Slug',
    description: 'Уникальный код статуса (например, IN_PROGRESS, CLOSED)',
  }),

  color: StringField({
    title: 'Цвет',
    nullable: true,
    maxLength: 50,
    description: 'Цвет для отображения в интерфейсе (Mantine color name или hex)',
  }),

  planned_duration_days: IntegerField({
    title: 'План, дней',
    nullable: true,
    description: 'Ожидаемое количество дней нахождения сделки в статусе',
  }),

  is_active: BooleanField({
    title: 'Активный',
    default: true,
    description: 'Активен ли статус и доступен для выбора',
  }),

  is_final: BooleanField({
    title: 'Финальный статус',
    default: false,
    description: 'Финальный статус (успешно/неуспешно)',
  }),

  is_negative: BooleanField({
    title: 'Негативный исход',
    default: false,
    description: 'Негативный финальный статус (отмена, проигрыш)',
  }),

  description: StringField({
    title: 'Описание',
    nullable: true,
    maxLength: 500,
    description: 'Опциональное описание статуса',
  }),

  deal_type: RelationOne(dealTypeSchemaDefinition),
  deal_type_id: RelationField(dealTypeSchemaDefinition, 'ID типа сделки', {
    description: 'Тип сделки, к которому относится статус',
    relationName: 'deal_type',
  }),
});

export type DealStatus = Static<typeof DealStatusSchema>;

export default defineSchema({
  moduleName,
  tableName: 'deal_statuses', // System will prefix with 'crm_'
  schema: DealStatusSchema,
  additionalIndexes: [
    'name',
    'sort_order',
    'is_active',
    { columns: ['deal_type_id', 'slug'], unique: true },
  ],
});
